module.exports = __webpack_public_path__ + "img/a-new-challenger.f50e7c9d.png";